import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { SessionService } from '../services/session.service';

export const errorInterceptor: HttpInterceptorFn = (request, next) => {
  const router = inject(Router);
  const session = inject(SessionService);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      // Erros de sessão invalidam o estado local antes de devolver o erro para a tela.
      if (error.status === 401) {
        session.endSession(false);
        void router.navigateByUrl('/login');
      }

      if (error.status === 403) {
        void router.navigateByUrl('/acesso-negado');
      }

      return throwError(() => error);
    }),
  );
};
